import _ from 'lodash';

export default (url) => {
  try {
    const spl = `${url}`.split('/').filter(i => Number(i) && _.isInteger(Number(i)));
    return parseInt(spl[0], 10);
  } catch (error) {
    return error;
  }
};
